/**
 * Detect fn
 */
export default () => 'flat' in Array.prototype
